import { User, MessageType, OwnInfo, Apartment, ResponseBase } from "@/models";
import axios from "axios";

export default class UserService {
    public async SendPin(email: string, messageType: MessageType | null): Promise<boolean | null> {
        try {
            await axios.post("users/send-pin", {
                email,
                messageType,
            });
            return true;
        } catch (err) {
            return false;
        }
    }

    public async SendConfirmPin(address: string, messageType: MessageType): Promise<ResponseBase> {
        return(await axios.post("users/sendconfirmpin", { address: address, messageType: messageType })).data;
    }

    public async Exists(email: string): Promise<boolean> {
        return (await axios.get("users/exists", { params: { email } })).data;
    }

    public async Register(user: User): Promise<ResponseBase> {
        return (await axios.post("users/register", {
                firstName: user.firstName,
                lastName: user.lastName,
                ssn: user.ssn,
                phone: user.phone,
                streetAddress: user.streetAddress,
                zipCode: user.zipCode,
                city: user.city,
                email: user.email,
                isCompany: user.isCompany,
                businessId: user.businessId,
                companyName: user.companyName
            })).data;
    }

    public async SetHousingCompany(housingCompanyId: number): Promise<User> {
        return (await axios.post("users/sethousingcompany", { housingCompanyId })).data;
    }

    public async GetOwnInfo(): Promise<OwnInfo[]> {
        return (await axios.get("users/owninfo")).data;
    }

    public async RemoveHousingCompany(accountId: number): Promise<boolean> {
        return (await axios.post("users/removehousingcompany", { accountId })).data;
    }

    public async GetAccount(accountId: number): Promise<Account | null> {
        return (await axios.get(`users/getaccount/${accountId}`)).data;
    }

    public async GetApartments(housingCompanyId: number): Promise<Apartment[] | null> {
        return (await axios.get(`users/getapartments/${housingCompanyId}`)).data;
    } 

    public async UpdateOwnInfo(ownInfo: OwnInfo, additionalInfo: string | null): Promise<ResponseBase> {
        return (await axios.post("requests/owninfoedit", { ownInfo: ownInfo, additionalInfo: additionalInfo })).data;
    }

    public async UpdateOwnUserName(firstName: string, lastName: string): Promise<ResponseBase> {
        return (await axios.put("users/updateownusername", { firstName: firstName, lastName: lastName })).data;
    }

    public async UpdateOwnContact(address: string, messageType: MessageType, pin: string): Promise<ResponseBase> {
        return (await axios.put("users/updateowncontact", { address: address, messageType: messageType, pin: pin })).data;
    }
}
